module.exports = __webpack_public_path__ + "img/app-oio.9b0346b4.png";